export default (state = {}, action = {}) => {
    if (action.type === 'CURRENT_TEST_SERIES') {
        return action.payload;
    }
    return state;
};